import PreferredLocation from './PreferredLocation'

Vue.component(PreferredLocation.name, PreferredLocation)
